import React from 'react';
import addEmoji from '../modifiers/addEmoji.js';
import { EMOJI_TYPE } from '../types.js';
import EmojiPreviewModal from './emojiPreviewModal.js';
import 'wix-rich-content-editor-common';
import 'prop-types';
import 'react-custom-scrollbars';
import 'wix-rich-content-common';
import '../icons/JoyPixelsIcon.js';
import '../utils/getGroupEmojis.js';
import '../utils/convertUnicodeToEmoji.js';
import '../utils/emojiList.js';
import '../constants.js';
import '../icons/FaBell.js';
import '../icons/FaFlag.js';
import '../icons/FaHeart.js';
import '../icons/FaPaw.js';
import '../icons/FaSmile.js';
import '../icons/FaPlane.js';
import '../icons/FaUtensils.js';
import '../icons/FaRegFutbol.js';
import 'wix-rich-content-ui-components';

const EmojiInsertModal = ({ theme, t, helpers, setEditorState, getEditorState }) => {
  return /* @__PURE__ */ React.createElement(
    EmojiPreviewModal,
    {
      onAdd: (emoji) => {
        var _a, _b;
        const newEditorState = addEmoji(getEditorState(), emoji);
        setEditorState(newEditorState);
        (_a = helpers.onPluginAddSuccess) == null ? void 0 : _a.call(helpers, EMOJI_TYPE, "", {});
        (_b = helpers.closeModal) == null ? void 0 : _b.call(helpers);
      },
      theme,
      t
    }
  );
};

export { EmojiInsertModal as default };
//# sourceMappingURL=emojiInsertModal.js.map
